import { render, staticRenderFns } from "./MultipleInputs.vue?vue&type=template&id=1fb99d18"
import script from "./MultipleInputs.vue?vue&type=script&lang=js"
export * from "./MultipleInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports